// src/pages/Appli/AppliAdmin/ClubsNAAdmin.jsx

import React from "react";

import useScrollToTop from "../../../hooks/useScollToTop";

import ClubModal from "./ClubModal";
import ClubMembersModal from "./ClubMembersModal";

import ClubsAdminHeader from "./clubs-admin/components/ClubsAdminHeader";
import ClubsCardsMobile from "./clubs-admin/components/ClubsCardsMobile";
import ClubsFiltersBar from "./clubs-admin/components/ClubsFiltersBar";
import ClubsPagination from "./clubs-admin/components/ClubsPagination";
import ClubsResultsMeta from "./clubs-admin/components/ClubsResultsMeta";
import ClubsTableDesktop from "./clubs-admin/components/ClubsTableDesktop";

import useClubsAdmin from "./clubs-admin/hooks/useClubsAdmin";

export default function ClubsNAAdmin() {
  useScrollToTop();

  const { state, computed, actions } = useClubsAdmin();

  const {
    loading,
    deletingId,

    searchTerm,
    selectedDepartement,
    page,

    clubModal,
    membersModal,

    memberCountsByClub,
    memberCountsLoadingByClub,

    adherentCountsSavingByClub,
  } = state;

  const {
    departements,
    debouncedSearch,
    paginatedRows,

    totalClubs,
    totalDepartments,
    totalSites,
    totalAdherents,

    pageCount,
    hasActiveFilters,
  } = computed;

  return (
    <section className="w-full pb-10 pt-[96px] font-satoshi">
      <div className="mx-auto max-w-[1450px] px-4">
        <ClubsAdminHeader
          totalClubs={totalClubs}
          totalDepartments={totalDepartments}
          totalSites={totalSites}
          totalAdherents={totalAdherents}
        />

        <div className="mt-5">
          <ClubsFiltersBar
            searchTerm={searchTerm}
            setSearchTerm={actions.setSearchTerm}
            departements={departements}
            selectedDepartement={selectedDepartement}
            setSelectedDepartement={actions.setSelectedDepartement}
            hasActiveFilters={hasActiveFilters}
            onReset={actions.resetFilters}
            onCreate={actions.openCreate}
            loading={loading}
          />
        </div>

        <ClubsResultsMeta
          totalClubs={totalClubs}
          selectedDepartement={selectedDepartement}
          debouncedSearch={debouncedSearch}
          searchTerm={searchTerm}
          loading={loading}
          displayedCount={paginatedRows.length}
          page={page}
          pageCount={pageCount}
        />

        <div className="mt-5">
          <ClubsTableDesktop
            rows={paginatedRows}
            loading={loading}
            deletingId={deletingId}
            memberCountsByClub={memberCountsByClub}
            memberCountsLoadingByClub={memberCountsLoadingByClub}
            adherentCountsSavingByClub={adherentCountsSavingByClub}
            onSaveAdherentCount={actions.handleUpdateAdherentCount}
            onMembers={actions.openMembers}
            onEdit={actions.openEdit}
            onDelete={actions.handleDelete}
          />

          <ClubsCardsMobile
            rows={paginatedRows}
            loading={loading}
            deletingId={deletingId}
            memberCountsByClub={memberCountsByClub}
            memberCountsLoadingByClub={memberCountsLoadingByClub}
            adherentCountsSavingByClub={adherentCountsSavingByClub}
            onSaveAdherentCount={actions.handleUpdateAdherentCount}
            onMembers={actions.openMembers}
            onEdit={actions.openEdit}
            onDelete={actions.handleDelete}
          />
        </div>

        <ClubsPagination
          page={page}
          pageCount={pageCount}
          setPage={actions.setPage}
          loading={loading}
        />

        {clubModal.isOpen ? (
          <ClubModal
            isOpen={clubModal.isOpen}
            onClose={actions.closeClubModal}
            isEditMode={clubModal.isEditMode}
            clubId={clubModal.clubId}
            onRefresh={actions.fetchClubs}
          />
        ) : null}

        {membersModal.isOpen ? (
          <ClubMembersModal
            isOpen={membersModal.isOpen}
            onClose={actions.closeMembersModal}
            clubId={membersModal.clubId}
            clubName={membersModal.clubName}
            onMembersCountChange={actions.updateMemberCount}
          />
        ) : null}
      </div>
    </section>
  );
}